const React = require('react');
const { withPropTypeDependencies } = require('utils/strange-router-v3-shim');

module.exports = function withDependencyInstanceKey(Component, options = {}) {

    const WrappedComponent = withPropTypeDependencies(Component, options);
    const componentName = WrappedComponent.displayName || Component.displayName || Component.name || 'Component';

    function WithDependencyInstanceKey(props) {

        const {
            dependencyInstanceKey,
            ...componentProps
        } = props;

        return React.createElement(WrappedComponent, {
            ...componentProps,
            key: dependencyInstanceKey
        });
    }

    WithDependencyInstanceKey.displayName = `withDependencyInstanceKey(${componentName})`;
    WithDependencyInstanceKey.propTypes = WrappedComponent.propTypes;
    WithDependencyInstanceKey.dependencyPropTypes = WrappedComponent.dependencyPropTypes;
    WithDependencyInstanceKey.dependencyPropNames = WrappedComponent.dependencyPropNames;
    WithDependencyInstanceKey.WrappedComponent = WrappedComponent;

    return WithDependencyInstanceKey;
};
